



import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { ref, onValue } from 'firebase/database';
import { FaUserTie, FaBuilding, FaBriefcase } from 'react-icons/fa';
import slider2 from './Asstes/slider2.jpeg';
import slider3 from './Asstes/slider3.jpeg';
import mapImg from './Asstes/map_img.png';
import ceoImg from './Asstes/profile-img-vishal.jpg';
import aceoImg from './Asstes/manoj-jadhav.jpg';
import eeImg from './Asstes/Kundaliki-Bulae.jpg';
import sangliLogo from './Asstes/sanglizp.png';
import Navbar from './Navbar';
import Footer from './Footer';
import './bento-homepage.css';

const Homepage = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [stats, setStats] = useState({
        engOld: { total: 0, approved: 0, pending: 0, rejected: 0 },
        engNew: { total: 0, approved: 0, pending: 0, rejected: 0 },
        socOld: { total: 0, approved: 0, pending: 0, rejected: 0 },
        socNew: { total: 0, approved: 0, pending: 0, rejected: 0 },
        works: { total: 0, approved: 0, pending: 0, rejected: 0 }
    });
    const [loading, setLoading] = useState(true);
    const [animatedPerc, setAnimatedPerc] = useState(0);
    const [hovered, setHovered] = useState(null); // 'eng' | 'soc' | null

    const slides = [
        { id: 3, image: slider3 },
        { id: 2, image: slider2 },
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
        }, 5000);
        return () => clearInterval(timer);
    }, [slides.length]);

    useEffect(() => {
        const dataPaths = [
            { path: 'ekamwatapzp/EngineerRegistrations', key: 'engOld' },
            { path: 'ekamwatapzp/EngineerLotteryRegistrations', key: 'engNew' },
            { path: 'ekamwatapzp/SocietyRegistrations', key: 'socOld' },
            { path: 'ekamwatapzp/SocietyLotteryRegistrations', key: 'socNew' },
            { path: 'ekamwatapzp/WorkNames', key: 'works' }
        ];

        let loadedCount = 0;
        const tempStats = { 
            engOld: { total: 0, approved: 0, pending: 0, rejected: 0 }, 
            engNew: { total: 0, approved: 0, pending: 0, rejected: 0 }, 
            socOld: { total: 0, approved: 0, pending: 0, rejected: 0 }, 
            socNew: { total: 0, approved: 0, pending: 0, rejected: 0 },
            works: { total: 0, approved: 0, pending: 0, rejected: 0 }
        };

        const unsubscribers = dataPaths.map(({ path, key }) => {
            return onValue(ref(db, path), (snapshot) => {
                const data = snapshot.val() || {};
                const currentStats = { total: 0, approved: 0, pending: 0, rejected: 0 };
                
                const processItem = (item) => {
                    const status = item.status || 'Pending';
                    currentStats.total++;
                    if (status === 'Approved' || status === 'lottery_completed') currentStats.approved++;
                    else if (status === 'Rejected') currentStats.rejected++;
                    else currentStats.pending++;
                };

                if (key === 'works') {
                    Object.values(data).forEach(val => {
                        if (val && typeof val === 'object') {
                            if (val.schemeName) processItem(val);
                            else Object.values(val).forEach(subVal => {
                                if (subVal && typeof subVal === 'object' && subVal.schemeName) processItem(subVal);
                            });
                        }
                    });
                } else {
                    Object.values(data).forEach(processItem);
                }

                tempStats[key] = currentStats;
                loadedCount++;
                if (loadedCount >= 5) {
                    setStats({ ...tempStats });
                    setLoading(false);
                }
            });
        });

        return () => unsubscribers.forEach(unsub => unsub());
    }, []);

    const { totalRegistrations, socTotal, engTotal, socPercentage } = useMemo(() => {
        const totalReg = stats.engOld.total + stats.engNew.total + stats.socOld.total + stats.socNew.total;
        const sTotal = stats.socOld.total + stats.socNew.total;
        const eTotal = stats.engOld.total + stats.engNew.total;
        const sPerc = totalReg > 0 ? (sTotal / totalReg) * 360 : 0;
        return {
            totalRegistrations: totalReg,
            socTotal: sTotal,
            engTotal: eTotal,
            socPercentage: sPerc
        };
    }, [stats]);

    // Animation Effect
    useEffect(() => {
        if (!loading) {
            const timer = setTimeout(() => {
                setAnimatedPerc(socPercentage);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [loading, socPercentage]);

    return (
        <div className="bg-[#f4f7f6] min-h-screen flex flex-col">
            <Navbar />

            <section className="bento-section">
                <div className="bento-grid">
                    
                    {/* 1. HERO SLIDER CARD */}
                    <div className="bento-card hero-card col-span-12 lg:col-span-8 min-h-[250px] md:min-h-[400px] lg:min-h-0 relative overflow-hidden">
                        {slides.map((slide, index) => (
                            <div
                                key={slide.id}
                                className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                                    index === currentSlide ? "opacity-100 active" : "opacity-0"
                                }`}
                            >
                                <img
                                    src={slide.image}
                                    alt={`Slide ${index + 1}`}
                                    className="w-full h-full object-cover opacity-70"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                                {/* <div className="absolute bottom-10 left-10 right-10 z-10 hidden md:block">
                                    <h2 className="text-3xl font-black text-white mb-2 leading-tight">
                                        सुशासन आणि पारदर्शक <br/> विकास कामे
                                    </h2>
                                    <div className="w-16 h-1 bg-orange-500 rounded-full"></div>
                                </div> */}
                            </div>
                        ))}
                    </div>

                    {/* 2. WELCOME / BRANDING CARD */}
                    <div className="bento-card welcome-card col-span-12 lg:col-span-4 min-h-[300px] relative">
                        <div className="relative z-10 flex flex-col items-center h-full">
                            <div className="w-24 h-24 mb-6 bg-white/10 backdrop-blur-md rounded-3xl p-4 border border-white/20 shadow-2xl flex items-center justify-center transform hover:rotate-6 transition-transform">
                                <img src={sangliLogo} alt="ZP Logo" className="w-full h-full object-contain filter drop-shadow-lg" />
                            </div>
                            
                            <div className="space-y-2">
                                <h1 className="text-3xl font-black tracking-tight leading-tight">
                                    ई-काम वाटप प्रणाली
                                </h1>
                                <p className="text-sm font-bold text-teal-200/80 uppercase tracking-[0.2em] px-4 py-1.5 bg-white/5 rounded-full inline-block border border-white/5">
                                    सांगली जिल्हा परिषद
                                </p>
                            </div>

                            <div className="flex-grow flex items-center justify-center py-6">
                                <div className="h-0.5 w-12 bg-orange-500/50 rounded-full"></div>
                            </div>
                           
                            <Link to="/login" className="w-full group relative inline-flex items-center justify-center gap-3 bg-orange-500 text-white font-black py-4 px-8 rounded-2xl hover:bg-orange-600 transition-all hover:scale-[1.02] shadow-[0_10px_20px_-5px_rgba(249,115,22,0.4)] active:scale-95 overflow-hidden">
                                <span className="relative z-10">लॉगिन</span>
                                <svg className="relative z-10 group-hover:translate-x-1 transition-transform" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-orange-600 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                            </Link>
                        </div>
                    </div>

                    {/* 3. FLOATING TICKER CARD */}
                    <div className="ticker-card col-span-12 mx-2 md:mx-0 flex items-center">
                         <div className="bg-orange-500 text-white text-[9px] md:text-[10px] font-black uppercase tracking-tighter px-2 md:px-3 py-1 md:py-1.5 rounded-lg mr-2 md:mr-4 flex-shrink-0 animate-pulse">
                            नवे अपडेट्स
                         </div>
                         <div className="flex-1 overflow-hidden relative h-full flex items-center">
                            <div className="whitespace-nowrap absolute text-teal-900 font-bold text-xs md:text-sm tracking-wide" style={{ animation: 'marquee-bento 25s linear infinite' }}>
                                ई-निविदा प्रक्रिया आणि कामवाटप (लॉटरी) पद्धतीबाबत नवीन नियमावली लागू झाली आहे. &nbsp; | &nbsp; सुशिक्षित बेरोजगार अभियंता व मजूर सहकारी संस्थांसाठी पारदर्शक कामवाटप प्रक्रिया. &nbsp; | &nbsp; अधिक माहितीसाठी अधिकृत शासन परिपत्रके पहा.
                            </div>
                            <style>{`@keyframes marquee-bento { 0% { left: 100%; } 100% { left: -100%; } }`}</style>
                         </div>
                    </div>
                    {/* 6. IMPORTANT OFFICIALS ROW */}
                    <div className="profiles-row-card col-span-12">
                        <div className="bento-header !justify-center mb-4 md:mb-6">
                            <div className="icon-badge">👨‍💼</div>
                            <h3 className="text-xl md:text-2xl text-center">प्रशासकीय अधिकारी</h3>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                            <ProfileCardModern name="श्री. विशाल नरवाडे" post="मुख्य कार्यकारी अधिकारी" img={ceoImg} />
                            <ProfileCardModern name="श्री. मनोज जाधव" post="अतारीक्त मुख्य कार्यकारी अधिकारी" img={aceoImg} />
                            <ProfileCardModern name="श्री. कुंडलीक उबाळे" post="कार्यकारी अभियंता, सांगली" img={eeImg} />
                        </div>
                    </div>

                    {/* 4. STATISTICS SECTION (REPLACED INTRODUCTION CARD) */}
                    <div className="col-span-12 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
                        {/* Engineers Card */}
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col">
                            <div className="w-full p-4 text-center border-b border-gray-100 bg-gray-50/50 font-semibold text-gray-700">
                                सु.बे.अभियंता
                            </div>
                            <div className="flex w-full divide-x divide-gray-100 flex-grow">
                                <DashboardStatCategory title="जुने" data={stats.engOld} colorClass="text-blue-600" />
                                <DashboardStatCategory title="नवीन" data={stats.engNew} colorClass="text-blue-600" />
                            </div>
                        </div>

                        {/* Distribution Chart */}
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 flex flex-col items-center justify-center min-h-[400px]">
                            <h3 className="text-xs font-bold text-gray-700 mb-8 text-center uppercase tracking-wider">नोंदणी विभागणी</h3>
                            
                            <div className="relative w-40 h-40 md:w-48 md:h-48">
                                <svg viewBox="0 0 100 100" className="w-full h-full transform -rotate-90 group opacity-90">
                                    <circle cx="50" cy="50" r="40" fill="transparent" stroke="#f43f5e" strokeWidth={hovered === 'soc' ? "18" : "15"} pathLength="360" strokeDasharray={`${animatedPerc} ${360 - animatedPerc}`} className="transition-all duration-700 ease-out cursor-pointer" onMouseEnter={() => setHovered('soc')} onMouseLeave={() => setHovered(null)} />
                                    <circle cx="50" cy="50" r="40" fill="transparent" stroke="#2563eb" strokeWidth={hovered === 'eng' ? "18" : "15"} pathLength="360" strokeDasharray={`${360 - animatedPerc} ${animatedPerc}`} strokeDashoffset={`-${animatedPerc}`} className="transition-all duration-700 ease-out cursor-pointer" onMouseEnter={() => setHovered('eng')} onMouseLeave={() => setHovered(null)} />
                                </svg>
                                
                                <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                                    <span className="text-2xl font-black text-gray-800 tracking-tight">
                                        {hovered === 'eng' ? engTotal : (hovered === 'soc' ? socTotal : totalRegistrations)}
                                    </span>
                                    <span className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">
                                        {hovered === 'eng' ? 'अभियंता' : (hovered === 'soc' ? 'सोसायटी' : 'एकूण')}
                                    </span>
                                </div>
                            </div>

                            <div className="mt-8 flex flex-col gap-3 w-full text-[10px] font-black uppercase tracking-widest">
                                <div className="flex items-center justify-between px-2">
                                    <div className="flex items-center gap-2">
                                        <div className="w-2.5 h-2.5 rounded-full bg-blue-600"></div>
                                        <span className="text-gray-500">अभियंता</span>
                                    </div>
                                    <span className="text-blue-600 font-black">{engTotal}</span>
                                </div>
                                <div className="flex items-center justify-between px-2">
                                    <div className="flex items-center gap-2">
                                        <div className="w-2.5 h-2.5 rounded-full bg-rose-500"></div>
                                        <span className="text-gray-500">सोसायटी</span>
                                    </div>
                                    <span className="text-rose-600 font-black">{socTotal}</span>
                                </div>
                            </div>
                        </div>

                        {/* Societies Card */}
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col">
                            <div className="w-full p-4 text-center border-b border-gray-100 bg-gray-50/50 font-semibold text-gray-700">
                                मजूर सहकारी संस्था
                            </div>
                            <div className="flex w-full divide-x divide-gray-100 flex-grow">
                                <DashboardStatCategory title="जुने" data={stats.socOld} colorClass="text-rose-600" />
                                <DashboardStatCategory title="नवीन" data={stats.socNew} colorClass="text-rose-600" />
                            </div>
                        </div>

                        {/* Work Count Card - Now Side-by-Side */}
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col">
                            <div className="w-full p-4 text-center border-b border-gray-100 bg-gray-50/50 font-semibold text-gray-700 flex items-center justify-center gap-2">
                                <FaBriefcase className="text-emerald-600" size={14} /> एकूण कामे
                            </div>
                            <div className="flex-grow flex flex-col divide-y divide-gray-50">
                                <div className="flex-1 flex flex-col items-center justify-center py-6 bg-emerald-50/10">
                                    <span className="text-4xl font-black text-emerald-600">{stats.works.total}</span>
                                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em] mt-1">एकूण कामे</span>
                                </div>
                                <div className="grid grid-cols-1 divide-y divide-gray-50">
                                    <DashboardStatBox label="प्रलंबित कामे" count={stats.works.pending} colorClass="text-amber-500" />
                                    <DashboardStatBox label="मंजूर/पूर्ण कामे" count={stats.works.approved} colorClass="text-emerald-600" />
                                    <DashboardStatBox label="नाकारलेली कामे" count={stats.works.rejected} colorClass="text-rose-600" />
                                </div>
                            </div>
                        </div>
                    </div>

                    

                   

                    {/* 7. NEWS FEED CARD */}
                    <div className="bento-card news-card col-span-12 lg:col-span-6 lg:row-span-3 min-h-[300px] flex flex-col">
                        <div className="p-6 bg-red-600">
                             <h3 className="text-white font-bold flex items-center gap-2 text-md">
                                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"></path></svg>
                                नवीन घडामोडी
                             </h3>
                        </div>
                        <div className="p-3 overflow-y-auto flex-1 max-h-[300px] lg:max-h-full bg-slate-50">
                            <NewsTick text="जिल्हा परिषद सर्वसाधारण सभा दिनांक २२ रोजी आयोजित." />
                            <NewsTick text="पाणी पुरवठा विभागाची निविदा प्रसिद्ध झाली आहे." />
                            <NewsTick text="दहावी/बारावी गुणवंत विद्यार्थी सत्कार समारंभ." />
                        </div>
                        <div className="p-4 bg-white border-t border-gray-100 mt-auto">
                            <button className="w-full bg-red-50 text-red-600 border border-red-200 font-bold text-base md:text-lg uppercase py-3 rounded-xl hover:bg-red-600 hover:text-white transition-all shadow-sm flex items-center justify-center gap-2 group">
                                अधिक माहिती पहा 
                                <span className="group-hover:translate-x-1 transition-transform">→</span>
                            </button>
                        </div>
                    </div>

                    {/* 7. DISTRICT MAP CARD */}
                    {/* <div className="bento-card map-visual-card group">
                        <div className="absolute top-4 left-4 z-10 bg-white/80 backdrop-blur px-3 py-1 rounded-full text-[10px] font-bold text-teal-800 shadow-sm border border-teal-100">सांगली जिल्हा नकाशा</div>
                        <img src={mapImg} alt="Sangli Map" className="w-full h-full object-contain p-8 hover:scale-110 transition-transform duration-700 mix-blend-multiply" />
                    </div> */}

                    

                </div>
            </section>

            <Footer />

            <style>{`
                .active { z-index: 10; animation: fadeScale 1.2s ease-out; }
                @keyframes fadeScale { from { transform: scale(1.1); opacity: 0; } to { transform: scale(1); opacity: 1; } }
                .custom-scrollbar::-webkit-scrollbar { width: 4px; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
            `}</style>
        </div>
    );
};

/* Mini Components */

const ProfileCardModern = ({ name, post, img }) => (
    <div className="bento-card p-6 flex items-center gap-6 hover:border-orange-200 group">
         <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden border-4 border-white shadow-lg flex-shrink-0 group-hover:scale-110 transition-transform duration-500">
             <img src={img} alt={name} className="w-full h-full object-cover" />
         </div>
         <div>
             <h4 className="text-base md:text-lg font-black text-teal-900 leading-tight mb-1">{name}</h4>
             <p className="text-[10px] md:text-xs font-bold text-orange-600 uppercase tracking-widest">{post}</p>
             <div className="flex gap-2 mt-3">
                <div className="w-8 h-1 bg-teal-100 rounded-full"></div>
                <div className="w-4 h-1 bg-orange-200 rounded-full"></div>
             </div>
         </div>
    </div>
);

const NewsTick = ({ text }) => (
    <div className="py-2.5 px-3 border-b border-gray-200 last:border-0 hover:bg-white transition-colors cursor-default">
         <p className="text-xs font-semibold text-gray-700 leading-snug">
             <span className="text-blue-600 mr-2">•</span> {text}
         </p>
    </div>
);

const SchemePill = ({ title, icon, gradient }) => (
    <div className={`flex-1 rounded-3xl p-4 flex items-center justify-between shadow-md hover:shadow-xl hover:-translate-y-1 transition-all cursor-pointer bg-gradient-to-br ${gradient} text-white`}>
         <div className="flex items-center gap-3">
             <div className="w-10 h-10 bg-white/20 backdrop-blur rounded-xl flex items-center justify-center text-xl">
                 {icon}
             </div>
             <span className="font-bold text-sm tracking-wide">{title}</span>
         </div>
         <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path d="M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/></svg>
    </div>
);

const DashboardStatCategory = ({ title, data, colorClass }) => (
    <div className="flex-1 flex flex-col items-center">
        <div className="text-[11px] font-bold text-gray-400 p-2 w-full text-center uppercase tracking-wide bg-gray-50/30 border-b border-gray-100/50">
            {title}
        </div>
        <div className="grid grid-cols-1 divide-y divide-gray-50 flex-grow w-full">
            <DashboardStatBox label="एकूण नोंदणीकृत" count={data.total} colorClass="text-blue-600" />
            <DashboardStatBox label="प्रलंबित फाईल" count={data.pending} colorClass="text-amber-500" />
            <DashboardStatBox label="मंजूर फाईल" count={data.approved} colorClass="text-emerald-600" />
            <DashboardStatBox label="नाकारलेली फाईल" count={data.rejected} colorClass="text-rose-600" />
        </div>
    </div>
);

const DashboardStatBox = ({ label, count, colorClass }) => (
    <div className="flex flex-col items-center justify-center p-3 hover:bg-gray-50/50 transition-colors">
        <span className={`text-xl font-bold ${colorClass}`}>{count}</span>
        <span className="text-[10px] text-gray-400 font-bold uppercase tracking-tighter mt-0.5">{label}</span>
    </div>
);

export default Homepage;
